'use client'

import { useEffect, useMemo, useState } from 'react'
import { fetchCartRecommendationsApi } from '@/lib/commerce/services/cart-api'

export function useCartRecommendations(vendor: any, products: any[], limit = 5) {
  const [recommendedProducts, setRecommendedProducts] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)

  const cartProductIds = useMemo(() => products.map((p: any) => p.id).join(','), [products])

  useEffect(() => {
    const fetchRecommendations = async () => {
      if (!vendor?.id || products.length === 0) {
        setRecommendedProducts([])
        return
      }
      setIsLoading(true)
      const categoryIds = [...new Set(products.flatMap((p: any) => p.categories || []))] as string[]
      const excludeProductIds = products.map((p: any) => p.id)
      const result = await fetchCartRecommendationsApi(vendor.id, categoryIds, excludeProductIds, limit)
      if (result?.data) setRecommendedProducts(result.data)
      setIsLoading(false)
    }
    fetchRecommendations()
  }, [cartProductIds, vendor?.id])

  return { recommendedProducts, isLoading }
}
